import * as React from 'react';
import { IPaginationOptions } from './pagination';

export interface IPagingArrowsProps {
    paging: IPaginationOptions;
    isLeftArrows: boolean;
    onPageSelect(page: number): void;
}

/// <summary>
/// Renders left or right page arrow content
/// </summary>
/// <returns>Content text</returns>
export class PagingArrows extends React.Component<IPagingArrowsProps, any> {

    /// <summary>
    /// Calculates left or right page arrow content
    /// </summary>
    /// <returns>Left or right arrow JSX content</returns>
    GetResult() {
        if (this.props.paging.items === 0) return null;

        const numberOfPages = this.props.paging.totalPages;

        if (this.props.isLeftArrows) {
            const isDisabled = this.props.paging.currentPage === 1;
            const classNames = "pagination-arrows pagination-arrows-left" + (isDisabled ? " pagination-arrows-disabled" : "");
            return (
                <div className={classNames}>
                <button className="pagination-arrows-item" onClick={() => isDisabled ? false : this.props.onPageSelect(1)} disabled={isDisabled ? true: false}>
                  <svg className="svg-icon" aria-hidden="true" focusable="false">
                      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-double" />
                                  </svg>
                    <span className="visually-hidden">First Page</span>
                </button>
                <button className="pagination-arrows-item" onClick={() => isDisabled ? false : this.props.onPageSelect(this.props.paging.currentPage - 1)} disabled={isDisabled ? true : false}>
                  <svg className="svg-icon" aria-hidden="true" focusable="false">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron" />
                  </svg>
                  <span className="visually-hidden">Previous Page</span>
                </button>
                </div>
            );
        }
        else {
            const isDisabled = this.props.paging.currentPage === numberOfPages;
            const classNames = "pagination-arrows pagination-arrows-right" + (isDisabled ? " pagination-arrows-disabled" : "");
            return (
                <div className={classNames}>
                <button className="pagination-arrows-item" onClick={() => isDisabled ? false : this.props.onPageSelect(this.props.paging.currentPage + 1)} disabled={isDisabled ? true : false}>
                  <svg className="svg-icon" aria-hidden="true" focusable="false">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron" />
                  </svg>
                  <span className="visually-hidden">Next Page</span>
                </button>
                <button className="pagination-arrows-item" onClick={() => isDisabled ? false : this.props.onPageSelect(numberOfPages)} disabled={isDisabled ? true : false}>
                  <svg className="svg-icon" aria-hidden="true" focusable="false">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron-double" />
                  </svg>
                  <span className="visually-hidden">Last Page</span>
                </button>
                </div>
            );
        }
    }

    render() {
        return this.GetResult();
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/components/pagination/paging-arrows.tsx